<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="part-one">
<h1>Part One</h1>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch007.vue?27042e5b